// 证书查询、证书页面
import request from '@/utils/request'
import edu_request from '@/utils/edu_request'

export function get_imgId(params) {
  return edu_request({
    url: 'personal/Certification/searchCertification',
    method: 'get',
    params
  })
}
export function get_img(params) {
  return request({
    url: 'personal/certification/downCertification',
    method: 'get',
    params
  })
}
export function get_infos(params) {
  return request({
    url: 'personal/Certification/getCertificationInfo',
    method: 'get',
    params
  })
}
// 证书查询列表
export function searchCertification(params) {
  return edu_request({
    url: 'personal/Certification/searchCertification',
    method: 'get',
    params
  })
}
export function searchCertificationNew(params) {
  return edu_request({
    url: 'personal/Certification/searchCertificationNew',
    method: 'get',
    params
  })
}

// 我的证书
export function getMyCertification(params) {
  return edu_request({
    url: 'personal/Certification/MyCertification',
    method: 'get',
    params
  })
}